import { render, staticRenderFns } from "./Spin.vue?vue&type=template&id=0ca48608&scoped=true"
import script from "./Spin.vue?vue&type=script&lang=js"
export * from "./Spin.vue?vue&type=script&lang=js"
import style0 from "./Spin.vue?vue&type=style&index=0&id=0ca48608&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca48608",
  null
  
)

export default component.exports